import { render, staticRenderFns } from "./DesignerManager.vue?vue&type=template&id=4bfbf30a&scoped=true"
import script from "./DesignerManager.vue?vue&type=script&lang=js"
export * from "./DesignerManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbf30a",
  null
  
)

export default component.exports